import { render, staticRenderFns } from "./instruction-banner.vue?vue&type=template&id=81d330c8&"
import script from "./instruction-banner.vue?vue&type=script&lang=ts&"
export * from "./instruction-banner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports